<template>
  <div class="management_tree_item" :style="{ height: height }">
    <div class="tree_item">
      <label>
        <input type="checkbox" :checked="list.checked" />
        {{ list.checked }}
      </label>
      <img :src="list.avatar" alt="item.wx_name" />
      <span>{{ list.wx_name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ManagementTreeItem",
  data() {
    return {
      checked: false,
      checkList: {},
    };
  },
  watch: {
    list(val) {
      // console.log(val);
    },
  },
  props: {
    list: {
      type: Object,
      default: () => {},
    },
    height: {
      type: String,
      default: "0px",
    },
  },
};
</script>

<style lang="less" scoped>
.management_tree_item::after {
  content: "";
  display: inline-block;
  clear: both;
}
.management_tree_item {
  border: solid 1px #ccc;
  border-right: none;
  border-left: none;
  border-top: none;
  box-sizing: border-box;
  width: 94%;
  margin-left: calc(100% / 2 - 94% / 2);
  float: left;
  overflow: hidden;
  // height: auto;
}
.tree_item {
  float: left;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  // border: solid 1px blue;
  img {
    border: solid 1px #f0f0f0;
    width: 30px;
    height: 30px;
    border-radius: 100%;
    display: inline-block;
    margin-top: calc(55px / 2 - 36px / 2);
    margin-left: 20px;
    float: left;
  }
  span {
    line-height: 55px;
    float: left;
    height: 55px;
    width: 180px;
    // border: solid 1px;
    margin-left: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  label {
    width: 20px;
    height: 20px;
    display: inline-block;
    float: left;
    margin-top: calc(55px / 2 - 32px / 2);
    margin-left: 34px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/groupManagement/ManagementTreeList.vue